// client/src/routes/app/properties/$propertyId/building.tsx — SCR-PROP-003 tab „Clădire" · D-3910.
//
// The clădire of the apartment this property is, for an owner who lives in it as a resident: the
// residency card, the current tenant, the meters, the tickets (`PropertyBuildingTab`). The path is a
// contract: lane P-A's accept-and-link lands an owner here once he accepts the administrator's
// invitation, so it stays `/app/properties/$propertyId/building`.
//
// `?ticket=` is the shared search of the resident's routes (`myBuildingSearchSchema`), so a
// notification's ticket link opens that ticket on this tab as it does on „Clădirile mele" (D-3676).
// The layout already demands `Portfolio.Read`; the tab asks the clădire only for a session holding
// `Buildings.Self`, and shows a delegated session the empty state, with no request (D-3360).

import { createFileRoute } from '@tanstack/react-router';

import { PropertyBuildingTab } from '@/features/buildings/my/PropertyBuildingTab';
import { myBuildingSearchSchema } from '@/features/buildings/my/search';

export const Route = createFileRoute('/app/properties/$propertyId/building')({
  validateSearch: myBuildingSearchSchema,
  component: PropertyBuildingRoute,
});

function PropertyBuildingRoute() {
  const { propertyId } = Route.useParams();
  return <PropertyBuildingTab propertyId={propertyId} />;
}
